/**
 * this action uses REDUX to go to a specified route
 *
 * Created by Tom on 28/05/18
 */

import { push } from 'react-router-redux'

// go to a route
export const goToRoute = stringVal =>
    dispatch => {
        dispatch(push(stringVal))
    }



// WEBPACK FOOTER //
// ./src/actions/routerActions.js